module.exports = __webpack_public_path__ + "img/dashboard-icon.32ab8cbf.svg";